import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FuelTextArea } from '@frete.com/fuel-react';
import { minLengthObservations } from '../schema';
import * as Styled from './FieldObservationStyles';

function FieldObservation() {
  const { control, clearErrors, formState, setValue, register, watch } =
    useFormContext();
  const reasonValue = watch('reason');
  const observationsValue = watch('observations');
  const errorObservationsMessage = (formState.errors.observations?.message ||
    '') as string;
  const nameField = 'observations';

  if (reasonValue !== 'other') {
    return null;
  }

  return (
    <Styled.Wrapper>
      <Controller
        name={nameField}
        control={control}
        render={({ field: { onBlur } }) => (
          <FuelTextArea
            displayCounter
            name={nameField}
            placeholder="Conte mais detalhes aqui"
            data-testid={`textArea-${nameField}`}
            label="Motivo"
            onFuel-blur={onBlur}
            onFuel-input={(element) => {
              const value = element.target.value || '';
              setValue(nameField, value);

              if (
                errorObservationsMessage &&
                value.length >= minLengthObservations
              ) {
                clearErrors('observations');
              }
            }}
            ref={register(nameField).ref}
            state={errorObservationsMessage ? 'error' : undefined}
            hint={errorObservationsMessage}
            value={observationsValue}
            maxlength={100}
            rows={3}
          />
        )}
      />
    </Styled.Wrapper>
  );
}

export default FieldObservation;
